import { MERCHANT_BUSINESS_TYPE } from '../../../../constants/constants';

export function areFormSubmissionsEnabled(business = {}) {
  const { type: businessType } = business;
  return businessType === MERCHANT_BUSINESS_TYPE;
}
